/* a11y.js — patch DOM di accessibilità per markup generato da bundle senza sorgenti
   (Splide dentro app.min.js, listing React main.apps.products_list.js, app terze parti). */
(function () {
  'use strict';
  var L = window.a11yLabels || {};
  var seenColor = new WeakSet(), seenLink = new WeakSet(), seenImg = new WeakSet();
  var t = function (k, d) { return L[k] || d; };

  function fixSplide(root) {
    root.querySelectorAll('.splide__list').forEach(function (list) {
      // li[role=group] è valido solo se il <ul> ha role=presentation
      if (list.tagName === 'UL' && !list.getAttribute('role')) list.setAttribute('role', 'presentation');
      // <li> non ammette role=group/tabpanel/region/button (WAI-ARIA in HTML): spostiamo la semantica sul primo figlio
      list.querySelectorAll(':scope > li[role]').forEach(function (li) {
        var role = li.getAttribute('role');
        if (role === 'presentation' || role === 'none') return;
        var child = li.firstElementChild;
        if (role === 'button') { li.removeAttribute('role'); return; } // thumbnail navigation: resta focusabile e cliccabile sul li
        var blockish = child && /^(DIV|SECTION|ARTICLE|FIGURE)$/.test(child.tagName);
        if (blockish && !child.hasAttribute('data-a11y-slide')) {
          child.setAttribute('data-a11y-slide', '');
          child.setAttribute('role', 'group');
          child.setAttribute('aria-roledescription', li.getAttribute('aria-roledescription') || t('slide', 'slide'));
          if (li.getAttribute('aria-label')) child.setAttribute('aria-label', li.getAttribute('aria-label'));
        }
        li.removeAttribute('role'); li.removeAttribute('aria-roledescription'); li.removeAttribute('aria-label');
      });
    });
    // landmark carousel univoci
    var used = {};
    root.querySelectorAll('.splide[role="region"]').forEach(function (s, i) {
      var name = s.getAttribute('aria-label');
      if (!name) {
        if (/main-carousel|product-media|gallery/i.test(s.id + ' ' + s.className)) { s.setAttribute('aria-label', t('gallery', 'Galleria immagini del prodotto')); return; }
        var wrap = s.closest('slider-component, .giunti-slider-container, .blog-related-products-banner, .featured-evidence-banner, .shopify-section, section');
        var sec = s.closest('.shopify-section, section');
        var h = (wrap && wrap.querySelector('h2')) || (sec && sec.querySelector('h2')) || (wrap && wrap.querySelector('h3')) || (wrap && wrap.querySelector('h1'));
        name = (h && h.textContent.trim().replace(/\s+/g, ' ')) || (t('carousel', 'Carosello') + ' ' + (i + 1));
      }
      var base = name; used[base] = (used[base] || 0) + 1;
      if (used[base] > 1) name = base + ' (' + used[base] + ')';
      if (s.getAttribute('aria-label') !== name) s.setAttribute('aria-label', name);
    });
    var en = { 'Next slide': t('next', 'Slide successiva'), 'Previous slide': t('prev', 'Slide precedente'), 'Go to first slide': t('first_slide', 'Vai alla prima slide'), 'Go to last slide': t('last_slide', 'Vai all\'ultima slide'), 'Select a slide to show': t('select_slide', 'Scegli una slide da mostrare') };
    root.querySelectorAll('.splide [aria-label]').forEach(function (el) {
      var l = el.getAttribute('aria-label'), m;
      if (en[l]) el.setAttribute('aria-label', en[l]);
      else if ((m = l.match(/^Go to slide (\d+)$/))) el.setAttribute('aria-label', t('go_to_slide', 'Vai alla slide') + ' ' + m[1]);
      else if ((m = l.match(/^(\d+) of (\d+)$/))) el.setAttribute('aria-label', m[1] + ' ' + t('of', 'di') + ' ' + m[2]);
    });
    root.querySelectorAll('.splide__arrow--prev:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', t('prev', 'Slide precedente')); });
    root.querySelectorAll('.splide__arrow--next:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', t('next', 'Slide successiva')); });
    root.querySelectorAll('.splide__arrow[title]').forEach(function (b) { b.removeAttribute('title'); });
  }

  // le card hanno due <span> (mobile/desktop) con lo stesso titolo: prendi il primo
  function headingText(el) {
    var span = el.querySelector('span');
    return ((span && span.textContent) || el.textContent).trim().replace(/\s+/g, ' ').split('::')[0].trim();
  }

  function fixContext(root) {
    root.querySelectorAll('a').forEach(function (a) {
      var txt = a.textContent.trim().replace(/\s+/g, ' ');
      if (!/^(vedi tutti|vedi tutto|scopri di più|scopri|leggi tutto|leggi di più|see all)$/i.test(txt) || a.hasAttribute('aria-label')) return;
      var wrap = a.closest('slider-component, .giunti-slider-container, .featured-evidence-banner, section, .shopify-section');
      var h = wrap && wrap.querySelector('h2, h3, h1'); var ctx = h && headingText(h);
      if (ctx && ctx !== txt) a.setAttribute('aria-label', txt + ': ' + ctx);
    });
    // card prodotto: se il titolo è già un link allo stesso prodotto, il link sull'immagine è ridondante per gli screen reader
    root.querySelectorAll('a.giunti-card__media').forEach(function (a) {
      var card = a.closest('.card, .product-card-wrapper, li'); if (!card || a.closest('.splide')) return; // Splide gestisce il tabindex: solo nelle griglie statiche
      var tl = card.querySelector('.giunti-card__heading a, .card__heading a, h3 a, h2 a');
      if (tl && tl.getAttribute('href') === a.getAttribute('href')) { a.setAttribute('aria-hidden', 'true'); if (a.getAttribute('tabindex') !== '-1') a.setAttribute('tabindex', '-1'); }
    });
    // contatore risultati del listing: annunciato quando cambia
    root.querySelectorAll('.giunti-listing-products-counter:not([role])').forEach(function (c) { c.setAttribute('role', 'status'); c.setAttribute('aria-live', 'polite'); });
  }

  function fixListing(root) {
    root.querySelectorAll('button.quick-add__submit[aria-labelledby]').forEach(function (b) {
      var ids = b.getAttribute('aria-labelledby').split(/\s+/);
      var ok = ids.every(function (id) { var el = document.getElementById(id); return el && el.textContent.trim(); });
      if (ok) { b.removeAttribute('aria-label'); return; }
      var card = b.closest('.card, .product-card-wrapper, li');
      var title = card && card.querySelector('.giunti-card__heading, .card__heading, h3, h2');
      var txt = (b.querySelector('span') && b.querySelector('span').textContent.trim()) || t('add', 'Aggiungi al carrello');
      var lbl = txt + (title ? ' - ' + headingText(title) : ''); if (b.getAttribute('aria-label') !== lbl) b.setAttribute('aria-label', lbl);
    });
    root.querySelectorAll('a.close[href^="javascript"]:not([aria-label])').forEach(function (a) { a.setAttribute('role', 'button'); a.setAttribute('aria-label', t('close', 'Chiudi')); });
    root.querySelectorAll('a.giunti-icon--search:not([aria-label])').forEach(function (a) { a.setAttribute('aria-label', t('search', 'Cerca')); });
    root.querySelectorAll('select.giunti-listing-sorting-select:not([aria-label])').forEach(function (s) {
      s.setAttribute('aria-label', t('sort', 'Ordina per'));
    });
    root.querySelectorAll('a.giunti-card__media').forEach(function (a) {
      var card = a.closest('.card, .product-card-wrapper, li');
      var title = card && card.querySelector('.card__heading, .giunti-card__heading, .giunti-card__title, h3, h2, .product-title, a:not(.giunti-card__media)');
      var name = title && headingText(title);
      if (!name) { try { name = decodeURIComponent(a.pathname.split('/').pop()).replace(/-/g, ' '); } catch (e) { name = ''; } }
      if (name && a.getAttribute('aria-label') !== name) a.setAttribute('aria-label', name); // sempre ricalcolato: React ricicla i nodi
    });
  }

  function fixHeadings() {
    var first = document.querySelector('h3.giunti-card__heading');
    if (!first) return;
    // heading immediatamente precedente alla prima card: se è un h1, le card diventano livello 2
    var prev = null;
    document.querySelectorAll('h1,h2,h3,h4,h5,h6,[role="heading"]').forEach(function (h) {
      if (h.offsetParent === null || h.closest('[id^="CybotCookiebot"]')) return; // heading nascosti / banner cookie
      if (h.compareDocumentPosition(first) & Node.DOCUMENT_POSITION_FOLLOWING) prev = h;
    });
    var lvl = prev ? (prev.getAttribute('aria-level') || prev.tagName.replace(/\D/g, '')) : '1';
    if (lvl !== '1') return;
    document.querySelectorAll('h3.giunti-card__heading:not([aria-level])').forEach(function (h) { h.setAttribute('aria-level', '2'); });
  }

  function bgLuminance(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var m = getComputedStyle(node).backgroundColor.match(/[\d.]+/g);
      if (m && (m.length < 4 || parseFloat(m[3]) > 0.5)) {
        var L = [m[0], m[1], m[2]].map(function (c) { c = c / 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); });
        return 0.2126 * L[0] + 0.7152 * L[1] + 0.0722 * L[2];
      }
      node = node.parentElement;
    }
    return 1; // bianco
  }

  function fixGeneric(root) {
    // h1 di fallback (pagine con sezioni che non lo prevedono)
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var hasH1 = Array.prototype.some.call(document.querySelectorAll('h1'), function (h) { return h.getClientRects().length > 0 && !h.closest('[aria-hidden="true"]'); });
    if (main && !hasH1 && !main.querySelector('[data-a11y-h1]')) {
      var h1 = document.createElement('h1'); h1.className = 'a11y-visually-hidden'; h1.setAttribute('data-a11y-h1', '');
      h1.textContent = (document.title || '').split(/\s[–|-]\s/)[0].trim() || document.title; main.insertBefore(h1, main.firstChild);
    }
    // gerarchia titoli nei contenuti redazionali: nessun salto di più di un livello
    if (main) {
      var prev = 1;
      main.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (h) {
        if (h.offsetParent === null) return;
        var lvl = parseInt(h.getAttribute('aria-level') || h.tagName.slice(1), 10);
        if (lvl > prev + 1) { lvl = prev + 1; h.setAttribute('aria-level', String(lvl)); }
        prev = lvl;
      });
    }
    // iframe senza titolo
    root.querySelectorAll('iframe:not([title]):not([aria-hidden="true"])').forEach(function (f) {
      var host = ''; try { host = new URL(f.src, location.href).hostname.replace(/^www\./, ''); } catch (e) {}
      f.setAttribute('title', (t('embedded', 'Contenuto incorporato') + (host ? ': ' + host : '')));
    });
    // PageFly: pallini slider senza nome, area scorrevole non focusabile
    root.querySelectorAll('[data-pf-type] button:not([aria-label]):not([title])').forEach(function (b, i) {
      if (b.textContent.trim() || b.querySelector('img[alt]:not([alt=""])')) return;
      var sib = b.parentElement ? Array.prototype.indexOf.call(b.parentElement.children, b) + 1 : i + 1;
      b.setAttribute('aria-label', t('go_to_slide', 'Vai alla slide') + ' ' + sib);
    });
    root.querySelectorAll('.pf-media-slider:not([tabindex])').forEach(function (s) { s.setAttribute('tabindex', '0'); });
    // elementi focusabili ma invisibili (es. paginazione carousel nascosta)
    root.querySelectorAll('.splide__pagination button, .splide__pagination__page').forEach(function (b) {
      var r = b.getBoundingClientRect(); var hidden = (r.width === 0 || r.height === 0 || b.offsetParent === null);
      if (hidden) { b.setAttribute('tabindex', '-1'); b.setAttribute('aria-hidden', 'true'); }
      else if (b.getAttribute('tabindex') === '-1' && b.getAttribute('aria-hidden') === 'true') { b.removeAttribute('tabindex'); b.removeAttribute('aria-hidden'); }
    });
    // landing: testo bianco su colore chiaro -> testo scuro
    root.querySelectorAll('.landing-hero-title.text-white, .landing-hero-description.text-white, .landing-hero-description-mobile.text-white, .cta-banner__title, .cta-banner__description').forEach(function (el) {
      if (getComputedStyle(el).color !== 'rgb(255, 255, 255)' && !el.style.color) return;
      var lum = bgLuminance(el); if (lum === null) return;
      el.style.color = (1.05 / (lum + 0.05) < 4.5) ? '#161615' : ''; // contrasto del bianco sullo sfondo
    });
    // colori non conformi introdotti da PageFly / contenuti (rosso #e6332a, azzurro #46819f, grigio #8b8b8b)
    var map = { 'rgb(230, 51, 42)': '#e5271e', 'rgb(70, 129, 159)': '#447d9a', 'rgb(139, 139, 139)': '#767676', 'rgb(0, 119, 204)': '#0075c8', 'rgb(255, 143, 39)': '#bc5b00' };
    var colorRoots = root.querySelectorAll('[data-pf-type], .giunti-main-page__content, .rte, .landing-hero-container');
    if (colorRoots.length) colorRoots.forEach(function (cr) { cr.querySelectorAll('a, button, h1, h2, h3, h4, h5, h6, p, span, strong, li, td').forEach(function (el) {
      if (seenColor.has(el)) return; seenColor.add(el);
      if (el.children.length && !el.matches('a, button')) return;
      var cs = getComputedStyle(el);
      if (map[cs.color] && !el.hasAttribute('data-a11y-color')) { el.style.setProperty('color', map[cs.color], 'important'); el.setAttribute('data-a11y-color', ''); }
      if (map[cs.backgroundColor] && !el.hasAttribute('data-a11y-bg')) { el.style.setProperty('background-color', map[cs.backgroundColor], 'important'); el.setAttribute('data-a11y-bg', ''); }
    }); });
    // immagini senza attributo alt (contenuti redazionali): alt dal nome file
    root.querySelectorAll('img:not([alt])').forEach(function (img) {
      if (seenImg.has(img)) return; seenImg.add(img);
      var n = ''; try { n = decodeURIComponent(new URL(img.src, location.href).pathname.split('/').pop()); } catch (e) {}
      n = n.replace(/\.[a-z0-9]+$/i, '').replace(/[-_]+/g, ' ').replace(/\b(small|medium|large|\d{2,4}x\d{2,4})\b/gi, '').replace(/\s+/g, ' ').trim();
      img.setAttribute('alt', n);
    });
    // link senza testo nei contenuti (mailto, condivisione): nome dall'indirizzo
    root.querySelectorAll('main a[href]:not([aria-label]):not([aria-labelledby])').forEach(function (a) {
      if (seenLink.has(a)) return; seenLink.add(a);
      if (a.textContent.trim() || a.querySelector('img[alt]:not([alt=""]), svg[aria-label], [aria-label]')) return;
      var href = a.getAttribute('href') || '';
      if (href === '/' || href === location.origin || href === location.origin + '/') { a.setAttribute('aria-label', 'Home'); return; }
      if (href.indexOf('mailto:') === 0) a.setAttribute('aria-label', 'Email: ' + href.slice(7).split('?')[0]);
      else if (a.id === 'shareLink' || /share|condivid/i.test(href + a.className)) a.setAttribute('aria-label', t('share', 'Condividi'));
      else { var hn = ''; try { hn = new URL(a.href, location.href).hostname.replace(/^www\./, ''); } catch (e) {} if (hn) a.setAttribute('aria-label', (a.classList.contains('store-link') ? t('buy_on', 'Acquista su') : 'Link:') + ' ' + hn); }
    });
    // link di condivisione social nei contenuti: nome e dimensione
    root.querySelectorAll('a[href*="sharer.php"], a[href*="twitter.com/intent"], a[href*="pinterest.com/pin"], a[href*="linkedin.com/share"], a[href*="wa.me"], a[href*="api.whatsapp"]').forEach(function (a) {
      if (!a.getAttribute('aria-label') && !a.textContent.trim()) { var h = ''; try { h = new URL(a.href).hostname.replace(/^www\./, '').split('.')[0]; } catch (e) {} a.setAttribute('aria-label', t('share_on', 'Condividi su') + ' ' + h); }
      a.classList.add('a11y-share-link');
    });
  }

  function fixThirdParty(root) {
    // Header fisso clonato allo scroll: i landmark restano solo sull'header originale (niente banner/nav/search duplicati)
    document.querySelectorAll('.giunti-sticky-header__clone:not([role])').forEach(function (e) { e.setAttribute('role', 'region'); e.setAttribute('aria-label', t('sticky_header', 'Intestazione fissa')); });
    document.querySelectorAll('.giunti-sticky-header__clone header:not([role]), .giunti-sticky-header__clone nav:not([role]), .giunti-sticky-header__clone footer:not([role])').forEach(function (e) { e.setAttribute('role', 'none'); });
    document.querySelectorAll('.giunti-sticky-header__clone [role="search"], .giunti-sticky-header__clone [role="banner"], .giunti-sticky-header__clone [role="navigation"]').forEach(function (e) { e.setAttribute('role', 'none'); });
    // App di upsell (ufe): l'app la appende in fondo al body, sotto il footer. La si porta dentro la pagina,
    // in un landmark con nome, e si puliscono i titoli ("Titolo::Sottotitolo" -> "Titolo").
    document.querySelectorAll('body > .ufe-widget').forEach(function (w) {
      var main = document.getElementById('MainContent') || document.querySelector('main'); if (!main || !w.querySelector('.ufe-style-inpage')) return;
      var box = main.querySelector('.g-upsell');
      if (!box) {
        box = document.createElement('section'); box.className = 'g-upsell';
        var ref = main.querySelector('[id$="__cart-footer"]');
        if (ref && ref.nextSibling) main.insertBefore(box, ref.nextSibling); else main.appendChild(box);
      }
      box.appendChild(w);
    });
    document.querySelectorAll('.g-upsell').forEach(function (box) {
      var tt = box.querySelector('.popTitle'); var name = tt ? (tt.textContent || '').trim() : '';
      if (name && box.getAttribute('aria-label') !== name) box.setAttribute('aria-label', name);
      box.hidden = !box.querySelector('.upsellBody');
      box.querySelectorAll('.upsellTitle span, .upsellTitle a').forEach(function (e) {
        if (e.children.length === 0 && e.textContent.indexOf('::') !== -1) e.textContent = e.textContent.split('::')[0].trim();
      });
    });
    root.querySelectorAll('#salepify-embed-widget__toast-close-button:not([aria-label]), [id^="salepify"] button:not([aria-label]):empty').forEach(function (b) { b.setAttribute('aria-label', t('close', 'Chiudi')); });
    // Cassetto del carrello (app Hue, "wow-cart"): chiusura senza nome e non usabile da tastiera, titolo h4 fuori sequenza
    root.querySelectorAll('.wow-cart-header__close-btn[role="button"]:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', t('close', 'Chiudi')); if (!b.hasAttribute('tabindex')) b.tabIndex = 0;
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); } });
    });
    root.querySelectorAll('h4.wow-cart-header__title:not([aria-level])').forEach(function (h) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); });
    var sea = root.querySelector('#sea-accessibility-skip-links:not([role])');
    if (sea) { sea.setAttribute('role', 'navigation'); sea.setAttribute('aria-label', t('skip', 'Skip link')); }
    root.querySelectorAll('[arial-label]').forEach(function (el) {
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.getAttribute('arial-label'));
    });
    root.querySelectorAll('a[href="#"]:not([role]) .st-custom-button').forEach(function (b) {
      var a = b.parentElement; a.setAttribute('role', 'button');
      a.setAttribute('aria-label', t('share_on', 'Condividi su') + ' ' + (b.dataset.network || ''));
    });
  }

  function run(root) { root = root || document; fixSplide(root); fixListing(root); fixContext(root); fixHeadings(); fixGeneric(root); fixThirdParty(root); }

  var timer = 0, dirty = false;
  function schedule() {
    dirty = true; if (timer) return;
    // debounce: una sola esecuzione ogni 250 ms al massimo, con setTimeout (rAF non gira nei tab in background)
    timer = setTimeout(function () { timer = 0; if (dirty) { dirty = false; run(document); } }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  window.addEventListener('load', function () { run(document); setTimeout(function () { run(document); }, 1500); });
  new MutationObserver(function (ms) {
    // ignora le mutazioni prodotte dalle nostre stesse patch (attributi aria/tabindex) e i cambi di classe puramente estetici
    for (var i = 0; i < ms.length; i++) { var m = ms[i]; if (m.type === 'childList' || (m.type === 'attributes' && m.attributeName === 'role')) { schedule(); return; } }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['role'] });
})();
